export enum GeoFenceAction {
  ENTER = "ENTER",
  EXIT = "EXIT",
}

export enum GeoFenceAccuracy {
  DESIRED_ACCURACY_NAVIGATION = "DESIRED_ACCURACY_NAVIGATION",
  DESIRED_ACCURACY_HIGH = "DESIRED_ACCURACY_HIGH",
  DESIRED_ACCURACY_MEDIUM = "DESIRED_ACCURACY_MEDIUM",
  DESIRED_ACCURACY_LOW = "DESIRED_ACCURACY_LOW",
}

export enum GeoFenceAddressType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export interface GeofenceListItem {
  _id: string;
  action: GeoFenceAction;
  timestamp: string;
  latitude: number;
  longitude: number;
  accuracy?: GeoFenceAccuracy;
  addressType?: GeoFenceAddressType;
  geofenceIdentifier?: string;
  error?: string;
  participantId: string;
  enrollmentId: string;
  testResultId?: string;
  notificationId?: string;
  participantName: string;
  programName: string;
  source?: string;
  osType?: string;
  createdAt: string;
}

export interface GeofenceSearchResponse {
  geofences: GeofenceListItem[];
  totalCount: number;
}

export interface GeofenceSearchParams {
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortOrder: number;
  search?: string;
  action?: string;
  addressType?: string;
  programId?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface ValidationRequestSettings {
  metersRadiusGeofenceRequestValidation?: number;
  metersGeofenceAccuracyThreshold?: number;
  minutesPingGeofenceValidationRequest?: number;
  minutesPingGeofenceAlive?: number;
  automaticGeofenceTrigger?: boolean;
  requestGeofenceValidationsPerDay?: number;
  minimumMinsGeofenceBetweenRequestValidations?: number;
  showGeofenceChip?: boolean;
  distanceFilterGeofenceRequestValidation?: number;
  timerValidationRequestOpened?: number;
  minutesTimeToCompleteValidation?: number;
  validationRequestMaxAttempts?: number;
}

export interface GeofenceDetailParticipant {
  _id: string;
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
}

export interface GeofenceDetailProgram {
  _id: string;
  name: string;
  configuration?: {
    validationRequestSettings?: ValidationRequestSettings;
  };
}

export interface GeofenceDetailEnrollment {
  _id: string;
  status: string;
  programId: string;
  startDate?: string;
  endDate?: string;
}

export interface GeofenceDetail {
  _id: string;
  action: GeoFenceAction;
  timestamp: string;
  latitude: number;
  longitude: number;
  error?: string;
  accuracy?: GeoFenceAccuracy;
  geofenceIdentifier?: string;
  addressType?: GeoFenceAddressType;
  osType?: string;
  uuid?: string;
  locationAccuracy?: number;
  speed?: number;
  batteryLevel?: number;
  batteryCharging?: boolean;
  createdAt: string;
  participant?: GeofenceDetailParticipant;
  enrollment?: GeofenceDetailEnrollment;
  program?: GeofenceDetailProgram;
  testResult?: Record<string, any>;
  notification?: Record<string, any>;
}
